<dxp-link state="enabled" [openInNewTab]="this.params.linkData.openInNewTab" type="dxp-btn-custom-link"
    [text]="this.params.value" [href]="this.generatedUrl" aria-label="Click on the link to open">
</dxp-link>